// #region Import
import "./styles/_main.scss";
import "@288a/web-core";
import "@288a/web-cms";
import "@288a/web-gtag";
import "@288a/web-sentry";
import "@288a/web-login";
import "@288a/web-admin";
import "@288a/ecommerce-core";
import "@288a/ecommerce-catalog";
import "@288a/ecommerce-carts";
import "@288a/ecommerce-documents";
import "@288a/payment-core";
import "@288a/payment-stripe";
// #endregion
// #region Plugin
host.plugins.register({
    // #region Vars
    name: "288a.web.portal.mkw",
    // #endregion
    // #region Register
    register() {
        host.components.registerAll(require.context('./views', true, /(?<!views)\.vue$/));
    }
    // #endregion
});
// #endregion
